import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { getAllBrandsKey } from "./useGetAllBrand";

type CreateBrand = {
    brand: BrandWrite | BrandPatch;
};

export const useCreateBrand = () => {
    const queryClient = useQueryClient();
    const query = useMutation({
        mutationFn: async (options: CreateBrand) => {
            const { brand } = options;

            const { id, ...fields } = brand;

            return id === undefined ?
                    await loggedInApiCall.post("/api/brands", fields)
                :   await loggedInApiCall.patch("/api/brands/" + id, fields, {
                        headers: { "Content-Type": "application/merge-patch+json" },
                    });
        },
        onSuccess: () => queryClient.invalidateQueries([getAllBrandsKey]),
    });

    return query;
};

export type BrandWrite = {
    id?: number;
    name: string;
    organization: IRI;
    logoUrl?: string | null;
    sharedWithOrganizations?: IRI[];
    sharedWithAllSubsidiaries?: boolean;
};

export type BrandPatch = { id: number } & Partial<Omit<BrandWrite, "id">>;

export const BrandWriteSchema: z.ZodSchema<BrandWrite> = z.object({
    id: z.number().optional(),
    name: z.string(),
    organization: z.string(),
    logoUrl: z.string().optional(),
    sharedWithOrganizations: z.array(z.string()).optional(),
    sharedWithAllSubsidiaries: z.boolean().optional(),
});
